export const DATE_FORMATS = {
  TABLE_LAYOUT_FORMAT: "ddd, MMM-DD, YYYY - hh:mm:ss A",
};
